'use client';
import Carousel from '@ui/Carousel';
import { getItems, logEvent } from '@util/analytics';
import useLogWhenInView from '@util/hooks/useLogWhenInView';
import { useRecentlySearched } from '../hooks/useRecentlySearched';
import { renderProductCards } from '../utils';
import HomeSection from './Home/components/HomeSection';

const RecentlySearched = () => {
  const { recentlySearchedProducts, mostRecentTerm, isLoading } =
    useRecentlySearched();

  useLogWhenInView(() => {
    if (recentlySearchedProducts && recentlySearchedProducts.length > 5) {
      logEvent('view_item_list', {
        item_list_name: 'Recently Searched',
        item_list_id: 'recently_searched',
        items: getItems(recentlySearchedProducts),
      });
    }
  });
  if (
    isLoading ||
    (recentlySearchedProducts && recentlySearchedProducts.length > 5)
  ) {
    return (
      <HomeSection
        title="Recently Searched"
        subtitle={mostRecentTerm ? `"${mostRecentTerm}"` : undefined}
        href={`/search?keyword=${mostRecentTerm}`}
        target="_blank"
        linkText="See all"
        seeAllPosition="title"
        subtitleClassName="!text-[1.8rem]"
        carouselWrapper
      >
        <Carousel
          spacing={0}
          basis="basis-[48%] sm:basis-auto"
          loading={isLoading}
          items={renderProductCards(
            recentlySearchedProducts,
            {
              list_name: 'recently_searched',
              list_id: 'recently_searched',
            },
            {
              data_source: 'typesense',
              page: 'homepage',
              section: 'recently_searched',
            }
          )}
        />
      </HomeSection>
    );
  }
  return null;
};

export default RecentlySearched;
